import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

export const clinicService = {
  async getIndicators(entityId, date = null) {
    try {
      let url = `${ENDPOINTS.V3_CLINIC}/${entityId}/indicators`;
      if (date) url += `?date=${date}`;
      const response = await api.get(url);
      return { success: true, indicators: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar indicadores' };
    }
  },

  async getSettings(entityId) {
    try {
      const response = await api.get(`${ENDPOINTS.V3_CLINIC}/${entityId}/settings`);
      return { success: true, settings: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar configurações' };
    }
  },

  async updateSettings(entityId, payload) {
    try {
      const response = await api.put(`${ENDPOINTS.V3_CLINIC}/${entityId}/settings`, payload);
      return { success: true, settings: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao atualizar configurações' };
    }
  },
};
